import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./DonationPage.css"; // Reuse existing styles

const DonationEmailFailure = () => {
  const { state } = useLocation();
  const navigate = useNavigate();
  const donationDetails = state?.donationDetails || {};

  const handleBackToHome = () => {
    navigate("/");
  };

  return (
    <div className="donation-failure-page">
      <h2>Donation Processed, Email Failed</h2>
      <p>
        Your donation of ${parseFloat(donationDetails.amount || 0).toFixed(2)}{" "}
        was successfully processed! However, we couldn’t send your confirmation
        email at this time.
      </p>
      <p>
        Please contact us at{" "}
        <a href="mailto:info@bonobohope.org">info@bonobohope.org</a> with any
        questions, and we’ll ensure you receive your receipt.
      </p>
      <button className="donation-button" onClick={handleBackToHome}>
        Back to Home
      </button>
    </div>
  );
};

export default DonationEmailFailure;
